import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { authLogin as actionAuthLogin } from '../../../redux/auth/actions';
import { selectSignUpInvite } from '../../../redux/auth/selectors';

import constants from '../../../constants';

import SignInForm from '../components/SignInForm';
import { selectMe } from '../../../redux/me/selectors';

class SignIn extends Component {
  static propTypes = {
    authLogin: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    inviteData: PropTypes.shape({}),
    navigateNext: PropTypes.func.isRequired,
  };

  static defaultProps = {
    inviteData: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: {},
    };
  }

  postData = (email, password, options = {}, callback) => {
    const { authLogin, inviteData } = this.props;

    return authLogin(email, password, { ...options, keep_invite: !!inviteData })
      .then(res => {
        if (res.data && res.data.error) {
          this.setState({ error: res.data.error });
          throw res.data.error;
        }

        return res;
      })
      .then(this.navigateMain)
      .catch(error => {
        if (callback) {
          callback({ error });
        }
        this.setState({
          error,
        });
      });
  };

  navigateMain = data => {
    const queryParams = new URLSearchParams(window.location.search);

    if (queryParams.has('redirect')) {
      window.location = queryParams.get('redirect');
    } else {
      let path = constants.BASE_URL;
      path = path.replace(/\/?$/, '/');
      path += this.routeLoginRoute(data);
      window.location = path;
    }
  };

  routeLoginRoute = () => {
    const { userData } = this.props;

    if (!userData) return;

    let path = '';
    if (userData && userData.properties && userData.properties.length) {
      path = `properties/${userData.properties[0].id}`;
    } else if (userData && userData.businesses && userData.businesses.length) {
      path = `commercial/${userData.businesses[0].id}`;
    }
    return path;
  };

  render() {
    return (
      <SignInForm
        // @todo - force remount when devTools state changes, might be a more elegant way around this
        key={JSON.stringify(this.props.devTools)}
        {...this.props}
        onSubmit={this.postData}
      />
    );
  }
}

const mapStateToProps = state => ({
  inviteData: selectSignUpInvite(state),
  userData: selectMe(state),
  devTools: state.devTools || null,
});

const bindAction = {
  authLogin: actionAuthLogin,
};

export default connect(
  mapStateToProps,
  bindAction,
)(SignIn);
